<template>
  <el-drawer
    title=""
    :with-header="false"
    :visible.sync="drawer"
    size="50%"
    direction="rtl"
    :before-close="handleClose">
    <div style="padding: 10px;">
      <el-descriptions title="计费信息" :column="2" border>
        <el-descriptions-item label="仪表名称">{{model.name}}</el-descriptions-item>
        <el-descriptions-item label="仪表编号">{{model.number}}</el-descriptions-item>
        <el-descriptions-item label="能耗类型">{{model.energy}}</el-descriptions-item>
        <el-descriptions-item label="下级数量">{{model.children_count}}</el-descriptions-item>
        <el-descriptions-item label="分摊类型">{{model.apportion_meter_type}}</el-descriptions-item>
        <el-descriptions-item label="分摊模式">{{model.apportion_type}}</el-descriptions-item>
        <el-descriptions-item label="分摊人数">{{model.customer_count}}</el-descriptions-item>
        <el-descriptions-item label="所在级别">{{model.depth}}</el-descriptions-item>
        <el-descriptions-item label="上期读数">{{model.last_read_number}}</el-descriptions-item>
        <el-descriptions-item label="本期读数">{{model.read_number}}</el-descriptions-item>
        <el-descriptions-item label="仪表用量">{{model.dosage_number}}</el-descriptions-item>
        <el-descriptions-item label="线损用量">{{model.x_dosage_number}}</el-descriptions-item>
        <el-descriptions-item label="计算公式">{{model.dosage_fun_name}}</el-descriptions-item>
        <el-descriptions-item label="线损分摊">{{model.x_only_dosage_number}}</el-descriptions-item>
        <el-descriptions-item label="线损累计">{{model.x_total_dosage_number}}</el-descriptions-item>
        <el-descriptions-item label="线损系数">{{model.proportion_value}}</el-descriptions-item>
        <el-descriptions-item label="线损基数">{{model.proportion_total}}</el-descriptions-item>
        <el-descriptions-item label="线损占比">{{model.proportion}}</el-descriptions-item>
        <el-descriptions-item label="线损模式">{{model.mol_apportion_type}}</el-descriptions-item>
        <el-descriptions-item label="本表单价">{{model.current_price}}</el-descriptions-item>
        <el-descriptions-item label="总分摊量">{{model.total_dosage_number}}</el-descriptions-item>
        <el-descriptions-item label="计费总额">{{model.total_amount}}</el-descriptions-item>
        <el-descriptions-item label="分摊总金额">
          <span style="color: red;">{{model.allocated_amount}}</span>
        </el-descriptions-item>
      </el-descriptions>
      <el-divider></el-divider>
      <el-table
        :data="model.order_list"
        style="width: 100%">
        <el-table-column prop="charge_name" label="收费标准" width="150"></el-table-column>
        <el-table-column prop="current_price" label="单价" width="100"></el-table-column>
        <el-table-column prop="dosage_number" label="仪表用量" width="100"></el-table-column>
        <el-table-column prop="x_dosage_number" label="线损用量" width="100"></el-table-column>
        <el-table-column prop="x_total_dosage_number" label="线损累计" width="100"></el-table-column>
        <el-table-column prop="total_dosage_number" label="总分摊量" width="100"></el-table-column>
        <el-table-column prop="total_amount" label="计费总额" width="100"></el-table-column>
        <el-table-column prop="allocated_amount" label="分摊总金额" width="100">
          <template slot-scope="scope">
            <span style="color: red;">{{scope.row.allocated_amount}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "MeterOrderDrawer",
  data() {
    return {
      drawer: false,
      model: {}
    };
  },
  methods: {
    show(model){
      this.drawer = true;
      this.model = model;
    },
    handleClose() {
      this.drawer = false;
      this.model = {};
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/MeterOrderDrawer.vue